import { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Button } from "./prtnr";
import { payPayoutRequest } from "./redux/slices/payoutRequestsThunk";

const ModalContainer = styled.div`
  width: 516px;
  border-radius: 12px;
  padding: 24px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--Padding-Normal, 16px);
  align-self: stretch;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Title = styled.h2`
  color: var(--Color-Text-Text, #212543);
  text-align: left;
  width: 100%;

  /* H6 */
  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const Highlight = styled.span`
  color: var(--Color-Brand-Secoundary, #6162c5);

  /* H6 */
  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const Champagne = styled.img`
  width: 174px;
  height: 174px;
`;

const PayoutViewModal = ({
  onClose,
  paidReferrals,
  totalReward,
  selectedRequest,
}) => {
  const dispatch = useDispatch();
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(null);

  // Validation
  if (!selectedRequest) {
    return (
      <ModalContainer>
        <Title>Error</Title>
        <p>No payout request selected.</p>
        <button onClick={onClose}>Close</button>
      </ModalContainer>
    );
  }

  const handlePay = async () => {
    if (!selectedRequest?._id || isProcessing) return;

    setIsProcessing(true);
    setError(null);

    try {
      await dispatch(payPayoutRequest(selectedRequest._id)).unwrap();
      onClose();
    } catch (err) {
      console.error("❌ Pay error:", err);

      const errorMessage =
        err || err?.data?.message || "Payment failed. Please try again.";
      setError(errorMessage);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handlePay();
    }
  };

  return (
    <ModalContainer>
      <Champagne
        src="https://d3nakrlcog1u3z.cloudfront.net/1751293449884-image (4).png"
        alt="Celebration champagne"
      />

      <Title>Payout Request #{selectedRequest.requestId}</Title>

      <Title>
        Amount: <Highlight>{selectedRequest.amount}</Highlight>
      </Title>
      {selectedRequest?.payout_status !== "paid" && (
        <Buttonswrapper>
          <Button
            variant="black"
            onClick={handlePay}
            onKeyDown={handleKeyDown}
            disabled={
              isProcessing ||
              !(selectedRequest && selectedRequest._id) ||
              selectedRequest.item?.status === "Paid"
            }
            tabIndex={0}
            role="button"
            aria-label={`Pay ${
              selectedRequest?.item?.amount
                ? `$${selectedRequest.item.amount.toFixed(2)}`
                : "amount"
            } to member`}
            width="100%"
          >
            {isProcessing ? (
              <div style={{ display: "flex", gap: "4px" }}>
                <Spinner />
                Processing Payment...
              </div>
            ) : (
              <>Pay to Member</>
            )}
          </Button>

          {/* Close button */}
          <Button
            onClick={onClose}
            disabled={isProcessing}
            aria-label="Close payout modal"
            variant="gray"
            width="100%"
          >
            {isProcessing ? "Processing..." : "Close"}
          </Button>
        </Buttonswrapper>
      )}

      {error && <ErrorMessage role="alert">{error}</ErrorMessage>}
    </ModalContainer>
  );
};

const ErrorMessage = styled.div`
  color: #dc3545;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 10px 0;
  font-size: 14px;
`;
const Buttonswrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Spinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid #ffffff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default PayoutViewModal;
